export interface ReleaseNoteDraft {
  title: string;
  content: string;
}

export const parseChatAnswer = (answer: string): ReleaseNoteDraft => {
  const text = answer
    .trim()
    .replace(/^```(?:markdown|md)?\s*\n/i, "")
    .replace(/\n```\s*$/, "")
    .trim();

  const [firstLine = "", ...rest] = text.split("\n");
  const heading = firstLine.match(/^#\s+(.+)$/);

  if (!heading) return { title: "", content: text };

  return { title: heading[1].replace(/\*\*/g, "").trim(), content: rest.join("\n").trim() };
};
